export const compareCardWrapClass = (
  selected: boolean,
  isPaper: boolean | null | undefined,
): string => {
  const parts = ['nq-compare-card-wrap', isPaper ? 'is-paper' : 'is-live'];
  if (selected) parts.push('is-selected');
  return parts.join(' ');
};
